import { TVehicle } from "../../models/inventory/interfaces/vehicle.interface";
import { ISkuVariant, TSku } from "../../models/inventory/interfaces/sku.interface";
import { types } from "../types/types";

export const setApplicationVehicle = (vehicle: TVehicle) => ({
  type: types.applicationSetVehicle,
  payload: vehicle,
});

export const clearApplicationVehicle = () => ({
  type: types.applicationSetVehicle,
  payload: null,
});

export const setApplicationSku = (sku: TSku) => ({
  type: types.applicationSetSku,
  payload: sku,
});

export const clearApplicationSku = () => ({
  type: types.applicationSetSku,
  payload: null,
});

export const setApplicationVariant = (variant: ISkuVariant) => ({
  type: types.applicationSetVariant,
  payload: variant,
});

export const clearApplicationVariant = () => ({
  type: types.applicationSetVariant,
  payload: null,
});

export const setApplicationLoanTime = (weeks: number) => ({
  type: types.applicationSetLoanTime,
  payload: weeks,
});

export const clearApplicationLoanTime = () => ({
  type: types.applicationSetLoanTime,
  payload: null,
});

export const setApplicationDownPayment = (value: number) => ({
  type: types.applicationSetDownPayment,
  payload: value,
});

export const clearApplicationDownPayment = () => ({
  type: types.applicationSetDownPayment,
  payload: null,
});

export const setApplicationPartnership = (partnership: string) => ({
  type: types.applicationPartnership,
  payload: partnership,
});

export const clearApplicationPartnership = () => ({
  type: types.applicationPartnership,
  payload: null,
});
